import React, { FC, forwardRef } from "react";
import { Input } from "./test.style";

type TextInputProps = React.ComponentProps<typeof Input>;

const TextInput: FC<TextInputProps> = forwardRef(({ ...props }, ref) => {
    return (
        <label>
            <Input {...props} ref={ref} />
        </label>
    );
});

TextInput.displayName = "TextInput";

export default TextInput;
